import UIDialogService from './UIDialogService';

export default UIDialogService;
